function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "80",
  height: "80",
  viewBox: "0 0 459 459"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M0 153v153h102l127.5 127.5v-408L102 153H0zm344.25 76.5c0-45.9-25.5-84.15-63.75-102v204c38.25-17.85 63.75-56.1 63.75-102zM280.5 5.1v53.55C354.45 81.6 408 147.899 408 229.5s-53.55 147.9-127.5 170.85v53.55C382.5 430.949 459 339.15 459 229.5S382.5 28.049 280.5 5.1z"
})));